var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-img',_vm._g(_vm._b({ref:"jcdcImg",attrs:{"src":_vm.imgFile,"contain":""}},'v-img',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }